export default __webpack_public_path__ + "static/media/topic0-bg1.4a557b5b.png";